import { render, staticRenderFns } from "./AiJobTagPicker.vue?vue&type=template&id=222689d7&scoped=true&"
import script from "./AiJobTagPicker.vue?vue&type=script&lang=js&"
export * from "./AiJobTagPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222689d7",
  null
  
)

export default component.exports